const version ='1.6.8'
export default version
console.log(version)
